<template lang="html">
  <div class="space" :class="[active, display]">
    <span class="name">{{message.Sl161}}: {{name}}</span>
    <el-popover
      ref="popover"
      placement="bottom"
      width="185"
      v-model='tabShow'
      trigger="click"
      @show='showTab'
      @hide="active=''"
    >
    <div class="info-cell role" v-if="type === 'join'">
      <span>{{message.Sl165}}</span>
      <span style="float:right;font-weight:600;">{{role.name}}</span>
    </div>
    <div class="info-cell" @click="show(0)">{{message.Sl124}}</div>
    <div class="info-cell" @click="show(1)">{{message.Sl140}}</div>
    <div class="info-cell" @click="show(2)" v-if="type === 'creat'||role.type ===1">{{message.Sl166}}</div>
    <div class="info-cell" @click="show(3)" v-if="type === 'creat'||role.type ===1">{{message.Sl191}}</div>
    <div class="info-cell" @click="show(4)">{{message.Sl215}}</div>
    <!-- <div class="info-cell flow" v-if="type === 'join'">
      <span>{{message.Sl167}}</span>
      <span style="float:right;font-weight:600;margin:4px 4px 0 0;font-size:18px">{{flow}}</span>
    </div> -->
    </el-popover>
    <i v-popover:popover class="material-icons operation">settings</i>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      space: 'space'
    })
  },
  watch: {
    'space.id': function (val, oldVal) {
      if (val !== oldVal) {
        this.getWorkspaceInfo()
      }
    },
    'space.name': function (val, oldVal) {
      if (val !== oldVal) {
        this.getWorkspaceInfo()
      }
    },
    $route: 'isShow',
  },
  data () {
    return {
      display: '',
      name: '',
      id: '',
      type: '',
      members: '',
      itemNum: 0,
      role: '',
      active: '',
      flow: '',
      tabShow: false,
      message: {
        Sl102: this.$lang.ui.system.l102,
        Sl161: this.$lang.ui.system.l161,
        Sl162: this.$lang.ui.system.l162,
        Sl163: this.$lang.ui.system.l163,
        Sl164: this.$lang.ui.system.l164,
        Sl165: this.$lang.ui.system.l165,
        Sl124: this.$lang.ui.system.l124,
        Sl140: this.$lang.ui.system.l140,
        Sl166: this.$lang.ui.system.l166,
        Sl167: this.$lang.ui.system.l167,
        Sl191: this.$lang.ui.system.l191,
        Sl215: this.$lang.ui.system.l215
      }
    }
  },
  mounted () {
    this.getWorkspaceInfo()
    this.isShow()
  },
  methods: {
    isShow () {
      switch (this.$route.path) {
        case '/app/workspace/inbox':
          this.display = ''
          break
        case '/app/workspace/outbox':
          this.display = ''
          break
        case '/app/workspace/history':
          this.display = ''
          break
        default:
          this.display = 'display-none'
      }
    },
    getWorkspaceInfo () {
      if (!this.space.id || this.space.id === 'none') {
        return
      }
      this.$api.getProject(this.space.id, response => {
        this.id = response.project.id
        this.name = response.project.name
        if (response.project.creater.id === localStorage.getItem('uid')) {
          this.type = 'creat'
        } else {
          this.type = 'join'
        }
      })
    },
    showTab () {
      this.active = 'active'
      this.$api.getUserRole(this.id, response => {
        if (response.permission.role === 0) {
          this.role = {
            type: 0,
            name: this.$lang.ui.system.l138
          }
        }
        if (response.permission.role === 1) {
          this.role = {
            type: 1,
            name: this.$lang.ui.system.l139
          }
        }
        if (response.permission.role === 2) {
          this.role = {
            type: 2,
            name: this.$lang.ui.system.l140
          }
        }
      })
      // if (this.type === 'creat') {
      //   return
      // }
      // var data = {
      //   user_id: this.creater.id,
      //   project_id: this.id
      // }
      // this.$api.getFlow(data, response => {
      //   if (response.user_quota.available_traffic < 0) {
      //     this.flow = '-' + this._global.trafficSwitch(-response.user_quota.available_traffic)
      //   } else {
      //     this.flow = this._global.trafficSwitch(response.user_quota.available_traffic)
      //   }
      // })
    },
    show (type) {
      if (type === 4) {
        this.tabShow = false
        this.$store.dispatch('showSpacelist', true)
        return
      }
      var data = [
        {
          role: this.role.type,
          type: 'workspace',
          spaceName: this.name,
          name: 'workspaceInfo',
          id: this.id
        },
        {
          role: this.role.type,
          type: 'workspace',
          spaceName: this.name,
          name: 'workspaceMembers',
          id: this.id
        },
        {
          role: this.role.type,
          type: 'workspace',
          spaceName: this.name,
          name: 'workspaceSettings',
          id: this.id
        },
        {
          role: this.role.type,
          type: 'workspace',
          spaceName: this.name,
          name: 'workspaceRecord',
          id: this.id
        }
      ]
      this.tabShow = false
      this.$store.dispatch('showOther', data[type])
    }
  }
}
</script>

<style scoped lang="css">
.display-none {
  display: none;
}
.space {
  position: relative;
  width: 100%;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
}
.space.active .operation {
  opacity: 1;
  display: block;
}
.space:hover {
  background-color: #fff;
}
.item {
  position: absolute;
  top: 0;
  left: 45px;
}
.img {
  float: left;
  width: 45px;
  height: 45px;
  border-radius: 45px;
  overflow: hidden;
  text-align: center;
}
.img img {
  width: 45px;
  height: 45px;
}
.icon-add {
  color: #fff;
  margin-top: 10px;
}
/* .word {
} */
.word span{
  width: 100%;
  padding-left: 10px;
  display: inline-block;
}
.name {
  display: block;
  float: left;
  height: 100%;
  margin-top: 0;
  font-size: 16px;
  margin-right: 10px;
}
.more {
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.operation {
  display: block;
  float: left;
  cursor: pointer;
  display: none;
  opacity: 0.6;
  font-size: 24px;
  margin-top: 10px;
}
.operation:hover {
  opacity: 1;
}
.space:hover .operation {
  display: inline-block;
}
.info-cell {
  padding: 6px 4px;
  cursor: pointer;
  border-radius: 2px;
}
.info-cell:hover {
  background-color: #fff;
}
.info-cell.role:hover,
.info-cell.flow:hover {
  background-color: #fff;
}
.info-cell.role {
  margin-bottom: 8px;
  border-bottom: 1px solid #ccc;
}
.info-cell.flow {
  margin-top: 8px;
  border-top: 1px solid #ccc;
}
.people {
  font-size: 20px;
}
</style>
